require('whatwg-fetch')
// 'fetch' is now a global
module.exports = window.fetch
